export default class TestingProgressDetail {
  public jobId: string
  public requiredTestingDocuments: number[]
  public missingTestingDocuments: number[]
  public testingComplete: boolean
}
